import { render, staticRenderFns } from "./PenilaianPelaksanaanUpt.vue?vue&type=template&id=e070bcb6&"
import script from "./PenilaianPelaksanaanUpt.vue?vue&type=script&lang=js&"
export * from "./PenilaianPelaksanaanUpt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports